import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Button,
  MenuItem,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: '#000000',
  boxShadow: 'none',
  position: 'fixed',
  transition: 'all 0.3s ease',
  borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
}));

const StyledToolbar = styled(Toolbar)({
  minHeight: '56px !important',
  padding: '0 !important',
});

const StyledButton = styled(Button)(({ theme }) => ({
  color: '#FFFFFF',
  fontSize: '0.85rem',
  fontWeight: 600,
  padding: '8px 20px',
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: 'rgba(212, 175, 55, 0.1)',
    color: '#D4AF37',
  },
  '&.active': {
    position: 'relative',
    color: '#D4AF37',
    fontWeight: 700,
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 20,
      right: 20,
      height: '2px',
      backgroundColor: '#D4AF37',
      boxShadow: '0 0 10px rgba(212, 175, 55, 0.6)',
    },
  },
}));

const Logo = styled('img')(({ theme }) => ({
  height: '44px',
  [theme.breakpoints.down('sm')]: {
    height: '36px',
  },
  transition: 'all 0.3s ease',
  '&:hover': {
    opacity: 0.9,
  },
}));

const pages = [];

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const location = useLocation();
  const theme = useTheme();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <StyledAppBar>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <StyledToolbar>
          {/* Desktop Logo */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 3 }}>
            <RouterLink to="/">
              <Logo
                src="/images/sls-logo.png"
                alt="SLS Luxury Services"
              />
            </RouterLink>
          </Box>

          {/* Mobile Menu */}
          <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="small"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              sx={{ color: '#D4AF37', p: 1 }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiPaper-root': {
                  backgroundColor: '#000000',
                  color: '#FFFFFF',
                  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.9)',
                  border: '1px solid rgba(212, 175, 55, 0.3)',
                },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  component={RouterLink}
                  to={page.path}
                  selected={location.pathname === page.path}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(212, 175, 55, 0.15)',
                      color: '#D4AF37',
                    },
                  }}
                >
                  <Typography textAlign="center">
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Mobile Logo */}
          <Box sx={{ 
            flexGrow: 1, 
            display: { xs: 'flex', md: 'none' }, 
            justifyContent: 'center',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}>
            <RouterLink to="/">
              <Logo
                src="/images/2.png"
                alt="SLS Luxury Services"
              />
            </RouterLink>
          </Box>

          {/* Desktop Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
            {pages.map((page) => (
              <StyledButton
                key={page.name}
                component={RouterLink}
                to={page.path}
                className={location.pathname === page.path ? 'active' : ''}
                onClick={handleCloseNavMenu}
                sx={{ py: 1 }}
              >
                {page.name}
              </StyledButton>
            ))}
          </Box>
        </StyledToolbar>
      </Container>
    </StyledAppBar>
  );
};

export default Navbar; 